import { PromptConfigData } from "@/types/risk-analysis";
import api from "./api";
import { AuthData } from "@/types/auth";
import log from "../utils/logger";

export const getAllPromptConfigs = async (user: AuthData): Promise<PromptConfigData[]> => {
  try {
    const response = await api.get(`/prompt-config?userId=${user.user.id}&isActive=true`);
    return response.data?.body.promptConfigs || [];
  } catch (error) {
    log.error("Error fetching prompt config:", undefined, error);
    throw error;
  }
};
